import { lazy } from "react";
import ZidRedirect from "../modules/auth/zid-redirect";

const Dashboard = lazy(() => import("../modules/user/dashboard"));
const KPIOverView = lazy(() => import("../modules/user/kpi-overview"));
const OrderAnalysis = lazy(() => import("../modules/user/order-analysis"));
const Orders = lazy(() => import("../modules/user/orders"));
const AllOrders = lazy(() => import("../modules/user/orders/all-orders"));
const Delivered = lazy(() => import("../modules/user/orders/deliverd"));
const NewOrders = lazy(() => import("../modules/user/orders/new-orders"));
const OrderSummery = lazy(() => import("../modules/user/orders/order-summery"));
const Shipping = lazy(() => import("../modules/user/orders/shipping"));

const Ranking = lazy(() => import("../modules/user/reports/ranking"));
const SalesTrend = lazy(() => import("../modules/user/reports/sales-trend"));
const Top10 = lazy(() => import("../modules/user/reports/top-10"));
const TopLoosers = lazy(() => import("../modules/user/reports/top-loosers"));
const TopWinners = lazy(() => import("../modules/user/reports/top-winners"));
const OrderReports = lazy(() => import("../modules/user/reports/order-reports"));
const SalesReports = lazy(() => import("../modules/user/reports/sales-reports"));
const ReturnsReports = lazy(() => import("../modules/user/reports/returns-reports"));

const SkuPerfomance = lazy(() => import("../modules/user/sku-perfomance"));
const Products = lazy(() => import("../modules/user/products"));
const Inventory = lazy(() => import("../modules/user/inventory"));
const AddProduct = lazy(() => import("../modules/user/products/add-product"));
const PublishProduct = lazy(() => import("../modules/user/products/publish-product"));
const Categories = lazy(() => import("../modules/user/categories"));
const Brands = lazy(() => import("../modules/user/brands"));
const Catalog = lazy(() => import("../modules/user/catalog"));
const Catalogs = lazy(() => import("../modules/user/catalogs"));
const ManualUpload = lazy(() => import("../modules/user/manual-upload"));
const BulkEnhance = lazy(() => import("../modules/user/bulk-enhance"));
const BulkEnhanceJobMonitor = lazy(() => import("../modules/user/bulk-enhance/components/JobMonitor"));
const ImportedReports = lazy(() => import("../modules/user/imported-reports"));
const AdsPerformance = lazy(() => import("../modules/user/ads-performance"));
const Exports = lazy(() => import("../modules/user/exports"));
const AddCredentials = lazy(() => import("../modules/user/credentials"));
const AppManagement = lazy(() => import("../modules/user/app-management"));
const SubscriptionPage = lazy(() => import("../modules/user/subscription"));
const CheckoutGateway = lazy(() => import("../modules/user/subscription/steps/CheckoutGateway"));

const CentralLogs = lazy(() =>
  import("../modules/user/application-logs/central-log")
);
const SystemErrorLogs = lazy(() =>
  import("../modules/user/application-logs/system-error-log")
);
const MyProfile = lazy(() => import("../modules/user/my-profile"));
const Account = lazy(() => import("../modules/user/account"));
const Roles = lazy(() => import("../modules/user/role-list"));
const UserManagement = lazy(() => import("../modules/user/user-management"));
const AccessDenied = lazy(() => import("../modules/access-denied"));

export const Users = [
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "orders",
    element: <Orders />,
  },
  {
    path: "shipping",
    element: <Shipping />,
  },
  {
    path: "order-summary",
    element: <OrderSummery />,
  },
  {
    path: "all-orders",
    element: <AllOrders />,
  },
  {
    path: "delivered",
    element: <Delivered />,
  },
  {
    path: "new-orders",
    element: <NewOrders />,
  },
  {
    path: "inventory",
    element: <Inventory />,
  },
  {
    path: "reports",
    element: <>Reports</>,
  },
  {
    path: "ranking",
    element: <Ranking />,
  },
  {
    path: "sales-trend",
    element: <SalesTrend />,
  },
  {
    path: "top-10",
    element: <Top10 />,
  },
  {
    path: "top-winners",
    element: <TopWinners />,
  },
  {
    path: "top-loosers",
    element: <TopLoosers />,
  },
  {
    path: "order-reports",
    element: <OrderReports />,
  },
  {
    path: "sales-reports",
    element: <SalesReports />,
  },
  {
    path: "returns-reports",
    element: <ReturnsReports />,
  },
  {
    path: "order-analysis",
    element: <OrderAnalysis />,
  },
  {
    path: "sku-perfomance",
    element: <SkuPerfomance />,
  },
  {
    path: "products",
    element: <Products />,
  },
  {
    path: "products/add",
    element: <AddProduct />,
  },
  {
    path: "products/publish",
    element: <PublishProduct />,
  },
  {
    path: "categories",
    element: <Categories />,
  },
  {
    path: "brands",
    element: <Brands />,
  },
  {
    path: "catalog",
    element: <Catalog />,
  },
  {
    path: "catalogs",
    element: <Catalogs />,
  },
  {
    path: "manual-upload",
    element: <ManualUpload />,
  },
  {
    path: "bulk-enhance",
    element: <BulkEnhance />,
  },
  {
    path: "bulk-enhance/jobs/:jobId",
    element: <BulkEnhanceJobMonitor />,
  },
  {
    path: "imported-reports",
    element: <ImportedReports />,
  },
  {
    path: "exports",
    element: <Exports />,
  },
  {
    path: "kpi-overview",
    element: <KPIOverView />,
  },
  {
    path: "ads-performance",
    element: <AdsPerformance />,
  },

  {
    path: "app-management",
    element: <AppManagement />,
  },
  {
    path: "subscription",
    element: <SubscriptionPage />,
  },
  {
    path: "subscription/pay",
    element: <CheckoutGateway />,
  },
  {
    path: "settings",
    element: <AddCredentials />,
  },
  {
    path: "callback-sp",
    element: <AddCredentials />,
  },
  {
    path: "callback-ads",
    element: <AddCredentials />,
  },
  {
    path: "applicatiion-logs/central-log",
    element: <CentralLogs />,
  },
  {
    path: "applicatiion-logs/system-error-log",
    element: <SystemErrorLogs />,
  },
  {
    path: "callback-salla",
    element: <AddCredentials />,
  },
  { path: "callback-zid", element: <AddCredentials /> },
  { path: "noon", element: <AddCredentials /> },
  { path: "trendyol", element: <AddCredentials /> },
  { path: "redirect-zid", element: <ZidRedirect /> },
  {
    path: "my-profile",
    element: <MyProfile />,
  },
  {
    path: "account",
    element: <Account />,
  },
  {
    path: "roles",
    element: <Roles />,
  },
  {
    path: "user-management",
    element: <UserManagement />,
  },
  {
    path: "access-denied",
    element: <AccessDenied />,
  },
];
